/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-30 09:41:39
 * @LastEditors: caiqin.xie
 * @message: 权益查询-查询结果组件
 */
import React, { useEffect, useState } from "react";
import { IconClose } from "@arco-design/web-react/icon";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
  snInfo: Record<string, any>; // 查询结果
  dialogVisible: boolean; // 查询结果弹框是否显示
  changeDialogVisible: (visible: boolean) => void; // 改变弹框显示状态
}

const QueryResult = (props:IProps) => {
  const {ctry, words, snInfo, dialogVisible} = props
  const [filterSnEquities, setFilterSnEquities] = useState<Record<string, any>[]>(null); // 过滤掉没有时间的权益
  // 过滤掉没有时间的权益
  useEffect(() => {
    if (snInfo?.snEquities && snInfo.snEquities.length > 0) {
      const filterList = snInfo.snEquities.filter((item: Record<string, any>) => item.time !== null)
      setFilterSnEquities(filterList)
    }
    console.log(filterSnEquities)
  }, [snInfo])

  return (
    <>
      {dialogVisible && (
        <div className={styles["dialog-mask-wrap"]}>
          <div className={styles["dialog-content"]}>
            <div className={styles['dialog-close']}>
              <IconClose className={styles['icon-close']} onClick={() => props.changeDialogVisible(false)} />
            </div>
            <div className={styles["dialog-title"]}>
              {words?.support_benefit_result_title}
              {/* Warranty & Support Service information */}
            </div>
            <div className={styles["dialog-container"]}>
              <div className={styles["dialog-body"]}>
                <div className={styles['product-pic']}>
                  <LazyMedia type="image" src={snInfo?.bProdActive?.url} alt={snInfo?.bProdActive?.alt} />
                </div>
                <ul className={styles["info-list"]}>
                  <li className={styles["info-sub-title"]}>{words?.support_benefit_result_product_info}</li>
                  <li className={styles["info-item"]}>
                    <span className={styles["info-label"]}>
                      {words?.support_benefit_result_product_model}
                      {/* Product model */}
                    </span>
                    <p className={styles["info-content"]}>
                      {snInfo?.bProdActive?.prodType}
                    </p>
                  </li>
                  <li className={styles["info-item"]}>
                    <span className={styles["info-label"]}>
                      {words?.support_benefit_result_product_SN}
                      {/* Product SN */}
                    </span>
                    <p className={styles["info-content"]}>
                      {snInfo?.bProdActive?.sn}
                    </p>
                  </li>
                  {(snInfo?.bProdActive?.sendArea || snInfo?.bProdActive?.country) && (
                    <li className={styles["info-item"]}>
                      <span className={styles["info-label"]}>
                        {words?.support_benefit_result_warranty_area}
                        {/* Product warranty area */}
                      </span>
                      <p className={styles["info-content"]}>
                        {snInfo?.bProdActive?.sendArea} {snInfo?.bProdActive?.country ? '/' : ''} {snInfo?.bProdActive?.country}
                      </p>
                    </li>
                  )}
                  <li className={styles["info-sub-title"]}>{words?.support_benefit_result_benefit_info}</li>
                  {(filterSnEquities && filterSnEquities.length > 0) ? (
                    <li className={styles["info-item"]}>
                      <p className={styles["info-content"]}>
                        {filterSnEquities.map((item: Record<string, any>) => (
                          <span className={styles["info-content-item"]} key={item.id}>{words?.[item.equityName]} {item?.time}</span>
                        ))}
                      </p>
                    </li>
                  ) : (
                    <li className={styles["info-item"]}>
                      <p className={styles["info-content"]}>{words?.support_benefit_result_null}</p>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default QueryResult